import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const POST_FUNKPROTOKOLL_VORLAGE_AKTUALISIEREN_ADMIN = '[VeranstaltungenModul] PostFunkprotokollVorlageAktualisierenAdmin laden';
export const POST_FUNKPROTOKOLL_VORLAGE_AKTUALISIEREN_ADMIN_AUSFUEHREN = '[VeranstaltungenModul] PostFunkprotokollVorlageAktualisierenAdmin ausführen';
export const POST_FUNKPROTOKOLL_VORLAGE_AKTUALISIEREN_ADMIN_ERFOLGREICH = '[VeranstaltungenModul] PostFunkprotokollVorlageAktualisierenAdmin laden erfolgreich';
export const POST_FUNKPROTOKOLL_VORLAGE_AKTUALISIEREN_ADMIN_FEHLER = '[VeranstaltungenModul] PostFunkprotokollVorlageAktualisierenAdmin Ladefehler';
export const POST_FUNKPROTOKOLL_VORLAGE_AKTUALISIEREN_ADMIN_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] PostFunkprotokollVorlageAktualisierenAdmin nicht ausgeführt (evtl. Offline)';


export class PostFunkprotokollVorlageAktualisierenAdminAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_VORLAGE_AKTUALISIEREN_ADMIN;
        constructor(public funkprotokollVorlageDatenRequest: api.FunkprotokollVorlageDatenRequest, public optPayload: any = null) {}
    }
export class PostFunkprotokollVorlageAktualisierenAdminAusfuehrenAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_VORLAGE_AKTUALISIEREN_ADMIN_AUSFUEHREN;
        constructor(public funkprotokollVorlageDatenRequest: api.FunkprotokollVorlageDatenRequest, public optPayload: any = null) {}
    }
export class PostFunkprotokollVorlageAktualisierenAdminErfolgreichAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_VORLAGE_AKTUALISIEREN_ADMIN_ERFOLGREICH;
        constructor(public payload: api.FunkprotokollVorlageIdentifier, public funkprotokollVorlageDatenRequest: api.FunkprotokollVorlageDatenRequest, public optPayload: any = null) {}
    }
export class PostFunkprotokollVorlageAktualisierenAdminFehlerAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_VORLAGE_AKTUALISIEREN_ADMIN_FEHLER;
        constructor(public payload: any, public funkprotokollVorlageDatenRequest: api.FunkprotokollVorlageDatenRequest, public optPayload: any = null) {}
    }
export class PostFunkprotokollVorlageAktualisierenAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_VORLAGE_AKTUALISIEREN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenCommandFunkprotokollVorlageAktualisierenAdminActions =
    PostFunkprotokollVorlageAktualisierenAdminAction
    | PostFunkprotokollVorlageAktualisierenAdminAusfuehrenAction
    | PostFunkprotokollVorlageAktualisierenAdminErfolgreichAction
    | PostFunkprotokollVorlageAktualisierenAdminFehlerAction
    | PostFunkprotokollVorlageAktualisierenAdminNichtAusgefuehrtAction
    ;
